module.exports = __webpack_public_path__ + "8f002cd6a20164db316664a4d8c9d0a5.jpg";